<template>
  <base-layout>
    <div style="margin-bottom:-20px;height:100%;overflow-y:auto;overflow-x:hidden;">
      <div class="row" style="margin-top:0px;">
        <div class="col-md-3 alert-header">
          <h4 class="box-section-heading">ALERTS</h4> <span class="span-color">{{alertCount}}</span>
        </div>
        <div class="col-md-9">

        </div>
      </div>
      <ob-layout :type="14">
        <template slot="left-section">
          <div class="filter-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <h3 class="titles">Filters</h3>
                </div>
                <div class="col-md-3 text-right" style="padding-left: 0px">
                  <h4 class="clr_btn" :disabled="isLoading" v-if="SearchIntent == 1" @click="onClrButtonClick">Clear</h4>
                </div>
                <div class="col-md-3" style="padding-top:6px">
                  <ob-button type="secondary" :disabled="btnDisable" @click="applyFilter()">Apply</ob-button>
                </div>
              </div>
              <!-- <div class="row content_btm">
                <h5 class="Sub_title">Sort Alerts By</h5>
                <div class="radio-inline">
                  <ob-radio name="options" val="RecentFirst" v-model="sortBy">Recent First</ob-radio>
                </div>
                <div class="radio-inline" style="padding-left: 0px;">
                  <ob-radio name="options" val="ImportantFirst" v-model="sortBy">Important First</ob-radio>
                </div>
                <div class="radio-inline" style="padding-left: 0px;">
                  <ob-radio name="options" val="UnNoticed" v-model="sortBy">Un-noticed</ob-radio>
                </div>
              </div> -->
              <div class="row content_btm">
                <h5 class="Sub_title">Date Range</h5>
                <div class="col-md-6">
                  <label>From</label>
                  <ob-date-time-picker :key="keyValueUpdate" :inputvalue="dateFrom" v-model="dateFrom" ref="dateFrom" id="dateFrom" :options="DateRangeFromOptions" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange"></ob-date-time-picker>
                </div>
                <div class="col-md-6">
                  <label>To</label>
                  <ob-date-time-picker :key="keyValueUpdate" :inputvalue="dateTo" v-model="dateTo" ref="dateTo" id="dateTo" :options="DateRangeToOptions" @updated="(v) => this.dateTo = v"></ob-date-time-picker>
                </div>
              </div>
            </div>
            <template v-for="(data,index) in AlertObject" v-if="loggedInUserObj.HireType == 'W2'">
                        <ob-collapse :type="9">
                            <h4 class="panel_title" slot="collapse-title">
                                {{alertGroup(data.AlertGroup)}}<span  class="alert-val" v-if="alertGroupLegendValue(data) != 0">{{alertGroupLegendValue(data)}}</span>
                            </h4>
                            <div class="collapse_content" slot="collapse-details">
                                <div class="checkbox-inline">
                                    <h5 class="panel_sub_title">View alerts for</h5>
                                    <template v-for="(preferenceType , Index) in data.AlertsPreference">
                                        <ob-checkbox :type="1"  v-model="preferenceType.IsEnable" :val="preferenceType.IsEnable">{{getPreferenceDisplayName(data.AlertGroup,preferenceType.AlertsPreferenceTypes)}}</ob-checkbox>
                                    </template>
                                </div>
                            </div>
                        </ob-collapse>
                    </template>
                      <template v-for="(data,index) in AlertObjectC2C" v-if="loggedInUserObj.HireType == 'C2C'">
                        <ob-collapse :type="9">
                            <h4 class="panel_title" slot="collapse-title">
                                {{alertGroup(data.AlertGroup)}}<span  class="alert-val" v-if="alertGroupLegendValue(data) != 0">{{alertGroupLegendValue(data)}}</span>
                            </h4>
                            <div class="collapse_content" slot="collapse-details">
                                <div class="checkbox-inline">
                                    <h5 class="panel_sub_title">View alerts for</h5>
                                    <template v-for="(preferenceType , Index) in data.AlertsPreference">
                                        <ob-checkbox :type="1"  v-model="preferenceType.IsEnable" :val="preferenceType.IsEnable">{{getPreferenceDisplayName(data.AlertGroup,preferenceType.AlertsPreferenceTypes)}}</ob-checkbox>
                                    </template>
                                </div>
                            </div>
                        </ob-collapse>
                    </template>
                      <template v-for="(data,index) in AlertObject1099" v-if="loggedInUserObj.HireType == '1099'">
                        <ob-collapse :type="9">
                            <h4 class="panel_title" slot="collapse-title">
                                {{alertGroup(data.AlertGroup)}}<span  class="alert-val" v-if="alertGroupLegendValue(data) != 0">{{alertGroupLegendValue(data)}}</span>
                            </h4>
                            <div class="collapse_content" slot="collapse-details">
                                <div class="checkbox-inline">
                                    <h5 class="panel_sub_title">View alerts for</h5>
                                    <template v-for="(preferenceType , Index) in data.AlertsPreference">
                                        <ob-checkbox :type="1"  v-model="preferenceType.IsEnable" :val="preferenceType.IsEnable">{{getPreferenceDisplayName(data.AlertGroup,preferenceType.AlertsPreferenceTypes)}}</ob-checkbox>
                                    </template>
                                </div>
                            </div>
                        </ob-collapse>
                    </template>
          </div>
        </template>
        <!-- Section -->
        <template slot="right-section" >
          <div class="alert-body">
            <div class="MT-Content-table" v-if="isLoading && alerts.length == 0">
              <div class="MT-Content">
                <ob-spinner></ob-spinner>
              </div>
            </div>
            <div class="row" style="margin:0px;" v-else-if="alerts && alerts.length > 0">
              <div @click="onAlertClick(data)" class="col-md-12 alert-content" :class="{'alert-content-unread':!data.IsRead}" v-for="(data, index) in alerts" :key="index">
                <div class="col-md-1" style="padding-left:10px;padding-right:0">
                  <img v-if="data.AlertType == 'Warning' " :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info-icon-orange.svg`' style="width:26px;border-radius:50%;margin-left:10px;">
                  <img v-else :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_red_icon.svg`' style="width:26px;border-radius:50%;margin-left:10px;">
                </div>
                <div class="col-md-11" style="padding-left:0px;">
                  <p style="font-weight:600;word-break: break-word;">{{data.Description}}</p>
                  <div class="alert-time">
                    <p class="mB0"> <i class="fa fa-clock-o" aria-hidden="true"></i> {{data.ModifiedDateTime | humantime}} </p>
                  </div>
                </div>
              </div>
              <div class=col-md-12>
                <a href="javascript:;" v-if="isLoadMore && !isLoading" @click="loadMore" class="load-more-link">Load More</a>
                <ob-spinner v-if="isLoading"></ob-spinner>
              </div>
            </div>
            <div class="MT-Content-table" v-else>
              <div class="MT-Content">
                <div style="margin-bottom: 20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_empty_alerts.svg`"></div>
                <div>All caught up!!</div>
              </div>
            </div>
          </div>
        </template>
      </ob-layout>
    </div>
  </base-layout>
</template>
<script>
export default {
  data() {
    return {
      keyValueUpdate:0,
      btnDisable:true,
      alertLength :'',
      sortBy:'',
      dateFrom:'',
      dateTo:'',
      SearchIntent : 0,
       AlertObjectC2C:[
        {
          AlertGroup:'W2C2CWorkAuthorization',
          AlertsPreference:[],
        },
        {
          AlertGroup:'TimeSheets',
          AlertsPreference:[],
        },
        // {
        //   AlertGroup:'Others',
        //   AlertsPreference:[],
        // },
      ],
      AlertObject1099:[
        {
          AlertGroup:'W2C2CWorkAuthorization',
          AlertsPreference:[],
        },
        {
          AlertGroup:'TimeSheets',
          AlertsPreference:[],
        },
        // {
        //   AlertGroup:'Others',
        //   AlertsPreference:[],
        // },
      ],
      AlertObject:[
     {
        AlertGroup:'EAD',
        AlertsPreference:[]
      },
      {
        AlertGroup:'FormI983',
        AlertsPreference:[]
      },
      
    
      {
        AlertGroup:'TimeSheets',
        AlertsPreference:[]
      },
      // {
      //   AlertGroup:'Others',
      //   AlertsPreference:[]
      // },
      ],
      DateRangeToOptions: {
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        widgetPositioning: {
          horizontal: 'right',
          vertical: 'bottom'
        }
      },
      DateRangeFromOptions: {
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        widgetPositioning: {
          horizontal: 'left',
          vertical: 'bottom'
        }
      },
      alerts: [],
      alertCount: 0,
      isLoading: true,
      isLoadMore: true,
      pageNo: 0,
      pageSize: 20,
      List:[],
      passwordCode:'',
      OrganizationAlertSettings:[]
      //isFilterApplied:false
    }
  },
  created() {
    this.getAlerts(0);
    this.getAlertSettings();   
    bus.listen("refreshProfileAlertsListener", () => {
       if(this.$route.name == "view-all-alerts")
       {
           this.applyFilter();
       }
    });

    this.interval = setInterval(() => {
         this.alerts = [];
         this.alerts = this.List;
    }, 1000);

    // this.getPassCode()
  },
  computed: {
  },
  watch:{
        sortBy(v1){ 
            if(v1 != '' || this.dateFrom != '' || this.dateTo != '' || this.alertLength != ''){
                this.btnDisable = false
            }
            else  this.btnDisable = true
        },
        dateFrom(v2){
              if(v2 != '' || this.sortBy != '' || this.dateTo != '' ||  this.alertLength > 0){
                this.btnDisable = false
            }  else  this.btnDisable = true
        },
        dateTo(v3){
              if(v3 != '' || this.sortBy != '' || this.dateFrom != '' ||  this.alertLength > 0){
			  		  
                this.btnDisable = false
            }  else  this.btnDisable = true
        },
        AlertObject: { 
            handler: function (val, oldVal) {
                for(let i=0;i<val.length;i++){
                    var len = val[i].AlertsPreference.filter(v=>v.IsEnable).length;
                    if(len > 0 || this.sortBy != '' || this.dateFrom != '' || this.dateTo != ''){
                        this.alertLength = len; 
                        this.btnDisable = false
                        break
                    }
                    else {
                        this.alertLength = len;
                        this.btnDisable = true
                    }
                }
            },
            deep: true
        },
        AlertObjectC2C: { 
            handler: function (val, oldVal) {
                for(let i=0;i<val.length;i++){
                    var len = val[i].AlertsPreference.filter(v=>v.IsEnable).length;
                    if(len > 0 || this.sortBy != '' || this.dateFrom != '' || this.dateTo != ''){
                        this.alertLength = len; 
                        this.btnDisable = false
                        break
                    }
                    else {
                        this.alertLength = len;
                        this.btnDisable = true
                    }
                }
            },
            deep: true
        },
        AlertObject1099: { 
          handler: function (val, oldVal) {
              for(let i=0;i<val.length;i++){
                  var len = val[i].AlertsPreference.filter(v=>v.IsEnable).length;
                  if(len > 0 || this.sortBy != '' || this.dateFrom != '' || this.dateTo != ''){
                      this.alertLength = len; 
                      this.btnDisable = false
                      break
                  }
                  else {
                      this.alertLength = len;
                      this.btnDisable = true
                  }
              }
          },
          deep: true
        }		
    },
  methods: {
    getPreferenceDisplayName(group , val){     
            if(group == 'W2C2CWorkAuthorization' && val == 'WorkAuthExpiry')
            {
                return "About to Expire/ Expiring Documents"
            }
            else if(val == 'DocExpiry'){
                return "Expiring Documents"
            }else if(val == 'Missing'){
                return "Missing Documents"
            }else if(val == 'Pending'){
                return "Pending Action/Expired Documents"
            }else if(val == 'SignatureRequestReminder'){
                return "Signature Request Reminder"
            }else if(val == 'WorkAuthExpiry'){
                return "Expiring Work Authorization Documents"
            }else if(val == 'TimeSheetApporvalReminder'){
                return `${this.timesheetLabel} Approval Reminder`
            }else if(val == 'LeaveApporvalReminder'){
                return "Leave Approval Reminder"
            }else if(val == 'PasswordExpiry'){
                return "Password Expiring Reminder"
            }
        },
    // getPassCode()
    // {
    //    this.$loading({'loadingText': 'Loading...'})
    //   ajax.get(`GeneratePasswordResetToken?userId=${loggedInUserObj.consultantId}`, {} , (res) => {
    //     if(res.data != null || res.data != ''){
    //         console.log(res)
    //        this.passwordCode = res.data;
    //     }
    //     this.$loading({}).close()
    //   })
    // },
    getDescription(desc)
    {
       return desc.replace(loggedInUserObj.name + "'s", "Your");
    },
    alertGroupLegendValue(group){   
            if(group.AlertGroup == "PersonnelFile"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }else if(group.AlertGroup == "Projects"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }
            else if(group.AlertGroup == "PAF"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }
            else if(group.AlertGroup == "EAD"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }else if(group.AlertGroup == "H1B"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }else if(group.AlertGroup == "FormI983"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }else if(group.AlertGroup == "FormI9"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }else if(group.AlertGroup == "TimeSheets"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }else if(group.AlertGroup == "Others"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            } else if(group.AlertGroup == "W2C2CWorkAuthorization"){
                return group.AlertsPreference.filter(v=>v.IsEnable).length;
            }
        },
    getAlertSettings(){
            this.$loading({'loadingText': 'Loading...'})
            ajax.get(`Employee/${this.loggedInUserObj.empId}/GetAlertSettings`, {} , (res) => {      
                if(res.data.State == true){
                    var result = res.data.OrganizationAlertSettings;
                    this.savedAlertSettings(result)
                }      
            })
            this.$loading({}).close()
        },
        savedAlertSettings(result){
            if(result != null && result != ''){
                this.getFormattedDate(result)
            }
        },
        getFormattedDate(settings)
        {
            if(this.loggedInUserObj.HireType == "W2")
            {
              for(var i=0; i< this.AlertObject.length ; i++)
              {
                  var alertPreference = settings.AlertSettings.filter(x=>x.AlertGroup == this.AlertObject[i].AlertGroup);
                  this.AlertObject[i].AlertsPreference = alertPreference;
                  for(var j=0;j< this.AlertObject[i].AlertsPreference.length;j++){
                      this.AlertObject[i].AlertsPreference[j].IsEnable = false
                  }
              }
            }
            if(this.loggedInUserObj.HireType == "C2C")
            {
              for(var i=0; i< this.AlertObjectC2C.length ; i++)
              {
                  var alertPreference = settings.AlertSettingsC2C.filter(x=>x.AlertGroup == this.AlertObjectC2C[i].AlertGroup);
                  this.AlertObjectC2C[i].AlertsPreference = alertPreference;
                  for(var j=0;j< this.AlertObjectC2C[i].AlertsPreference.length;j++){
                      this.AlertObjectC2C[i].AlertsPreference[j].IsEnable = false
                  }
              }
            }
            if(this.loggedInUserObj.HireType == "1099")
            {
              for(var i=0; i< this.AlertObject1099.length ; i++)
              {
                  var alertPreference = settings.AlertSettings1099.filter(x=>x.AlertGroup == this.AlertObject1099[i].AlertGroup);
                  this.AlertObject1099[i].AlertsPreference = alertPreference;
                  for(var j=0;j< this.AlertObject1099[i].AlertsPreference.length;j++){
                      this.AlertObject1099[i].AlertsPreference[j].IsEnable = false
                  }
              }
            }
        },
    alertGroup(name)
    {
      if(name == "PersonnelFile"){
        return 'Personnel File'
      }
     else if(name == "FormI983"){
        return 'Form I-983'
      }
      else if(name == 'Projects'){
        return 'Projects'
      }
      else if(name == 'PAF'){
        return 'PAF'
      }
      else if(name == 'EAD'){
        return 'EAD'
      }
      else if(name == 'H1B'){
        return 'H-1B'
      }
      else if(name == 'FormI9'){
        return 'Form I-9'
      }
      else if(name == 'TimeSheets'){
        return this.timesheetLabel
      }
      else if(name == 'Others'){
        return 'Others'
      }
      else if(name == "W2C2CWorkAuthorization"){
          return "Work Authorization Documents"
      }
    },
    showAlert(AlertGroup,alert)
    {
      var alertList = []
      var result = false
      switch(AlertGroup){
      case 'PAF':
        alertList = ["DocExpiry","Missing","Pending"]
        result = alertList.includes(alert)
        break;

      case 'H1B':
        alertList = ["DocExpiry","Missing","Pending","WorkAuthExpiry"]
        result = alertList.includes(alert)
        break;

      case 'FormI983':
        alertList = ["Pending"]
        result = alertList.includes(alert)
        break;

      case 'FormI9':
        alertList = ["DocExpiry","Pending"]
        result = alertList.includes(alert)
        break;

      case 'PersonnelFile':
        alertList = ["Missing"]
        result = alertList.includes(alert)
        break;

      case 'Projects':
        alertList = ["DocExpiry","Pending"]
        result = alertList.includes(alert)
        break;

        case 'Others':
        alertList = ["PasswordExpiry"]
        result = alertList.includes(alert)
        break;
      }
      return result;
    },
    onClrButtonClick() {
      this.keyValueUpdate++,
      this.isLoadMore = true;
      this.isLoading = true;
      this.alerts = [];
      this.alerts.length = 0;
      this.List = [];
      this.List .length = 0;
      //this.isFilterApplied = false;
      this.SearchIntent = 0;
      this.getAlerts();
      this.sortBy = '',
      this.dateFrom = '',
      this.dateTo = '',
      this.getAlertSettings()
      
    },
    onAlertClick(data) {
      let url="" ;
      this.$loading({"loadingText": "Updating..."})   
      var hireType = data.HireType != null ? data.HireType : "W2";
      if(!data.IsRead){
        this.readUnreadMethod(data.Id);
      }
      if(data.AlertGroup == "FormI983") {
        url = `/employee/form-i983`
      }
      else if(data.AlertGroup == "H1B") {
        if(hireType == "C2C" || hireType == "1099")
        {
          url = `/employee`
        }
        else
        {
        url = `/employee/h1b`
        }
      }
      else if(data.AlertGroup == "FormI9") {
        url = `/employee/i9`
      }
      else if(data.AlertGroup == "EAD"){
        if(hireType == "C2C" || hireType == "1099")
        {
          url = `/employee`
        }
        else
        {
          url = `/employee/ead`
        }
      }
      else if(data.AlertGroup == "Projects"){
        url = `/employee/projects`
      }
      else if(data.AlertGroup == "PersonnelFile"){
        url = `/employee/`
      }    
       else if(data.AlertGroup == "TimeSheets")
       {
          if(data.AlertClassification == "TimesheetPending"){
            if(data.EmployeeId == this.loggedInUserObj.empId){
              var str = data.Description;
              var sId = data.SourceId;
              var startDate = str.substring(31, 41);
              var endDate = str.substring(45, 55);
              var projectId = sId.replace(data.EmployeeId,"").replace(moment(startDate).format('YYYYMMDD')+moment(endDate).format('YYYYMMDD'),"")
              url = `/employee-addtimesheets?startDate=${startDate}&endDate=${endDate}&project=${projectId}`
            }
          }else{
            if(data.EmployeeId == this.loggedInUserObj.empId){
              url = `/my-timesheets`
            }else{
              localStorage.removeItem("SearchFilterPathLocation")
              localStorage.removeItem("SearchPathLocation")
              localStorage.removeItem("PathLocation")
              localStorage.removeItem("SearchPathLocation")
              localStorage.removeItem("searchText")
              localStorage.removeItem("IsSearchText")

            var calenderDate = data.FromDate != null ? moment(calenderDate).format("YYYY-MM-DD"):'';           

              url = `/employer-timesheets?calenderDate=${calenderDate}&searchText=${data.EmployeeEmail != null ? data.EmployeeEmail : ''}`
            }
          }
       }
       else if(data.AlertGroup == "Others")
      {
        url = `/SetPassword.html?empId=${data.EmployeeId}&pwdCode=${this.passwordCode}&consultantId=${loggedInUserObj.consultantId}&email=${data.RecepientEmail}`
      }
        
      if(url != "") {
        setTimeout(() => {
                    this.$loading({}).close();
                    window.open(url, "_self")
                }, 500)
      }
    },
    applyFilter()
    {
      this.pageNo = 0 ;
      this.List = [];
      this.alerts = [];
      this.isLoading = true;
      //this.isFilterApplied = true;
      this.SearchIntent = 1;
      this.getAlerts();
    },
    getAlerts() { 
            var alertPreference = [];
            if(this.loggedInUserObj.HireType == "W2")
            {
              for (var i = 0;i < this.AlertObject.length; i++){
                  for(var j = 0;j < this.AlertObject[i].AlertsPreference.length;j++){
                      if(this.AlertObject[i].AlertsPreference[j].IsEnable)
                      {
                          var pref = {
                              AlertsPreferenceTypes:this.AlertObject[i].AlertsPreference[j].AlertsPreferenceTypes,
                              IsEnable:this.AlertObject[i].AlertsPreference[j].IsEnable,
                              IsAlert:this.AlertObject[i].AlertsPreference[j].IsAlert,
                              IsMail:this.AlertObject[i].AlertsPreference[j].IsMail,
                              AlertGroup:this.AlertObject[i].AlertGroup
                          }
                          alertPreference.push(pref);
                      }
                  }
              }
            }
            if(this.loggedInUserObj.HireType == "C2C")
            {
             for (var i = 0;i < this.AlertObjectC2C.length; i++){
                for(var j = 0;j < this.AlertObjectC2C[i].AlertsPreference.length;j++){
                    if(this.AlertObjectC2C[i].AlertsPreference[j].IsEnable)
                    {
                      if(this.AlertObjectC2C[i].AlertGroup == "W2C2CWorkAuthorization")
                      {
                        var pref = {
                            AlertsPreferenceTypes:this.AlertObjectC2C[i].AlertsPreference[j].AlertsPreferenceTypes,
                            IsEnable:this.AlertObjectC2C[i].AlertsPreference[j].IsEnable,
                            IsAlert:this.AlertObjectC2C[i].AlertsPreference[j].IsAlert,
                            IsMail:this.AlertObjectC2C[i].AlertsPreference[j].IsMail,
                            AlertGroup:"H1B"
                        }
                        alertPreference.push(pref);

                         var pref = {
                            AlertsPreferenceTypes:this.AlertObjectC2C[i].AlertsPreference[j].AlertsPreferenceTypes,
                            IsEnable:this.AlertObjectC2C[i].AlertsPreference[j].IsEnable,
                            IsAlert:this.AlertObjectC2C[i].AlertsPreference[j].IsAlert,
                            IsMail:this.AlertObjectC2C[i].AlertsPreference[j].IsMail,
                            AlertGroup:"EAD"
                        }
                        alertPreference.push(pref);

                      }
                      else{
                        var pref = {
                            AlertsPreferenceTypes:this.AlertObjectC2C[i].AlertsPreference[j].AlertsPreferenceTypes,
                            IsEnable:this.AlertObjectC2C[i].AlertsPreference[j].IsEnable,
                            IsAlert:this.AlertObjectC2C[i].AlertsPreference[j].IsAlert,
                            IsMail:this.AlertObjectC2C[i].AlertsPreference[j].IsMail,
                            AlertGroup:this.AlertObjectC2C[i].AlertGroup
                        }
                        alertPreference.push(pref);
                      }
                    }
                }
            }
            }
            if(this.loggedInUserObj.HireType == "1099")
            {
             for (var i = 0;i < this.AlertObject1099.length; i++){
                for(var j = 0;j < this.AlertObject1099[i].AlertsPreference.length;j++){
                    if(this.AlertObject1099[i].AlertsPreference[j].IsEnable)
                    {
                      if(this.AlertObjectC2C[i].AlertGroup == "W2C2CWorkAuthorization")
                      {
                        var pref = {
                            AlertsPreferenceTypes:this.AlertObject1099[i].AlertsPreference[j].AlertsPreferenceTypes,
                            IsEnable:this.AlertObject1099[i].AlertsPreference[j].IsEnable,
                            IsAlert:this.AlertObject1099[i].AlertsPreference[j].IsAlert,
                            IsMail:this.AlertObject1099[i].AlertsPreference[j].IsMail,
                            AlertGroup:"H1B"
                        }
                        alertPreference.push(pref);

                         var pref = {
                            AlertsPreferenceTypes:this.AlertObject1099[i].AlertsPreference[j].AlertsPreferenceTypes,
                            IsEnable:this.AlertObject1099[i].AlertsPreference[j].IsEnable,
                            IsAlert:this.AlertObject1099[i].AlertsPreference[j].IsAlert,
                            IsMail:this.AlertObject1099[i].AlertsPreference[j].IsMail,
                            AlertGroup:"EAD"
                        }
                        alertPreference.push(pref);
                      }
                      else
                      {
                        var pref = {
                            AlertsPreferenceTypes:this.AlertObject1099[i].AlertsPreference[j].AlertsPreferenceTypes,
                            IsEnable:this.AlertObject1099[i].AlertsPreference[j].IsEnable,
                            IsAlert:this.AlertObject1099[i].AlertsPreference[j].IsAlert,
                            IsMail:this.AlertObject1099[i].AlertsPreference[j].IsMail,
                            AlertGroup:this.AlertObject1099[i].AlertGroup
                        }
                        alertPreference.push(pref);
                      }
                    }
                }
            }
            }
            var filterObj = {
                "FromDate" : this.dateFrom,
                "ToDate" : this.dateTo,
                "AlertSettings" : alertPreference
            }
            var Obj = {
                "SortBy" : this.sortBy,
                "Filter" : filterObj,
                "SearchIntent" : this.SearchIntent
            }
      ajax.put(`/Compliance/GetAlerts?empId=${this.loggedInUserObj.empId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`, Obj , (res) => {
        this.alertCount = res.data.Count
        var responseLength = res.data.AlertList.length;
        if(responseLength > 0) {
          this.alerts.push.apply(this.alerts, res.data.AlertList);
          this.List =  this.alerts ;
          if(responseLength == this.pageSize)
          {
              this.isLoadMore = true;
          }
          else
          {
              this.isLoadMore = false;
          }
        }
        else {
          this.isLoadMore = false;
        }
        this.isLoading = false;
      })
    },
    loadMore() {
      this.isLoading = true;
      this.pageNo++;
      this.getAlerts()
    },
    readUnreadMethod(k) {
      let _this = this;
      ajax.put(`/Compliance/AlertMarkedasReadOrUnread?alertId=${k}`, {}, ( res ) => {
        let index = this.alerts.findIndex(a => a.Id == k)
        if(index != -1) {
          Vue.set(this.alerts[index], "IsRead", !this.alerts[index].IsRead )
        }
      });
    },
    MarkAllAlertsAsRead() {
      this.$loading({"loadingText": "Updating..."})
      ajax.post(`/Compliance/MarkAllAlertsAsRead`,{},(res) => {
        this.$loading({"loadingText": "Updating..."}).close()
        this.alerts.forEach((a) => {
          Vue.set(a, "IsRead", true)
        })
      })
    },
    onFromDateChange(e) {
      this.$refs.dateTo.data.minDate(e.date)
    }
  },
}
</script>

<style lang="scss" scoped>
  .alert-container {
    height: 100%;
    box-shadow: #ddd 0px 0px 4px;
    padding: 0 15px;
   }
  .alert-header {
    padding-bottom: 5px;
    h4 {
      display: inline-block;
      padding-right: 10px;
      font-weight: 600;
    }
    .span-color {
      background: #FED4DE;
      color: #DD3D64;
      border-radius: 10px;
      padding: 0px 12px;
      font-weight: 600;
    }
  }
  .alert-body {
    height: 100%;
    overflow: auto;
    background: #fff;
    border-top: 0px;
  }
  .alert-content {
    cursor: pointer;
    padding: 15px 0px;
    border-bottom: 8px solid #F6F7F8;
    background: #fff;
  }
  .alert-content-unread {
    background: #fafafa;
  }
  .alert-time {
    padding: 5px 0px;
    p {
      display: inline-block;
      i {
        font-size: 13px;
        color: #777;
        padding-right: 5px;
      }
    }
  }
  .alert-view {
    float: right;
    font-style: italic;
    font-weight: 600;
    padding-right: 20px;
  }
  .load-more-link {
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 2%;
    display: block;
    text-align: center;
  }
  .float_right {
    float: right;
    padding-top: 4px;
  }
  .times {
    float: right;
    color: #ccc;
    padding: 5px 0px;
  }
  .display_none {
    display: none;
  }
  // .filter-body {
  //   overflow-y: auto;
  //   overflow-x: hidden;
  // }
  .titles {
    color: #143361;
    font-weight: 600;
    margin: 0;
    padding: 15px 0 15px;
  }
  .clr_btn {
    cursor: pointer;
    color: #4c9cde;
    font-weight: 600;
    margin: 0;
    padding: 15px 0 15px;
    font-size: 13px;
  }
  .Sub_title {
    color: #143361;
    font-weight: 650;
    padding-left: 15px;
  }
  .panel_sub_title {
    padding-top: 10px;
    color: #333333;
  }
  .panel_title {
    font-weight: bold;
    font-size: 14px;
    color: #323240;
  }
  .panel_btm {
    padding-bottom: 20px;
  }
  .content_btm {
    padding-bottom: 15px;
  }
  .alert-val {
    padding: 2px 6px;
    border-radius: 3px;
    background: #f41111;
    margin-left: 8px;
    color: #fff;
    font-size: 10px;
  }
  .radio-inline {
    padding-left: 15px
  }
  .checkbox-inline {
    padding-left: 15px;
  }
  .collapse_content {
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/AlertViewAll.vue